export const getItem = (key) => {
  try {
    const item = localStorage.getItem(key);
    if (item && !item.startsWith('{') && !item.startsWith('[')) {
      return item;
    }
    return JSON.parse(item);
  } catch (error) {
    return null;
  }
};
  
  export const setItem = (key, value) => {
    try {
      const serializedValue = JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
    } catch (error) {
    }
  };
  
  export const removeItem = (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
    }
  };
  